<template>
  <BaseAutocomplete
    :value="value"
    :search-function="searchProducts"
    :get-by-id-function="getProductById"
    :label="label"
    :initial-item="initialItem"
    :error-messages="errorMessages"
    :append-icon="appendIcon"
    :disabled="disabled"
    item-text="name"
    clearable
    @input="$emit('input', $event)"
    @update:initial-item="$emit('update:initial-item', $event)"
    @click:append="$emit('click:append')"
  />
</template>

<script>
import BaseAutocomplete from '@/components/base/BaseAutocomplete';
import i18n from '@/i18n/i18n-config';
import productService from '@/api/product-service';

export default {
  name: 'ProductAutocomplete',

  components: { BaseAutocomplete },

  props: {
    value: {
      type: Number,
      default: null,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    initialItem: {
      type: Object,
      default: () => null,
    },
    label: {
      type: String,
      default: () => i18n.t('general.product'),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    appendIcon: {
      type: String,
      default: '',
    },
  },

  methods: {
    searchProducts: productService.search,
    getProductById: productService.getById,
  },
};
</script>

<style scoped></style>
